import GroupSelectContainer from "./GroupSelectContainer";

export default GroupSelectContainer;
